export default "__VITE_ASSET__BnF86uaF__"